import abExperiments from '../../utils/abExperiments';
import isPageType from '../../utils/isPageType';
import { getBuyerId } from 'dibs-cookie-jar';

import '../../scss/tradeOnboarding.scss';

import { PAGE_TYPE } from '../../utils/pageConstants';
import {
    loadOnboardingModal,
    hasSeenModal,
    getModalType,
    fetchTradeUserData,
    LABEL_PDP,
    LABEL_SEARCH_BROWSE,
} from '../../utils/tradeOnboardingHelper';

const showNewOnboardingFlow = () => {
    if (abExperiments.tradeOnboardingFlow) {
        setTimeout(() => abExperiments.tradeOnboardingFlow.resolve(false), 1500);
        return abExperiments.tradeOnboardingFlow;
    } else {
        return Promise.resolve(false);
    }
};

function tradeOnboardingRule() {
    const isBlacklistedPage = isPageType([PAGE_TYPE.CHECKOUT, PAGE_TYPE.SOURCING]);
    if (!getBuyerId(document.cookie) || isBlacklistedPage || hasSeenModal()) {
        return Promise.resolve(false);
    }

    return fetchTradeUserData()
        .then(({ isVerifiedTrade }) => {
            if (!isVerifiedTrade) {
                return Promise.resolve(false);
            } else {
                return Promise.resolve(true);
            }
        })
        .catch(err => {
            console.error(err);
            return Promise.resolve(false);
        });
}

const tradeOnboardingShow = () => dispatch => {
    const label = isPageType(PAGE_TYPE.PDP) ? LABEL_PDP : LABEL_SEARCH_BROWSE;
    return Promise.all([fetchTradeUserData(), showNewOnboardingFlow()]).then(
        ([{ email }, showNewFlow]) => {
            return loadOnboardingModal({
                buyerEmail: email,
                showNewFlow,
                trackingLabel: `modal - ${label}`,
            }).then(() =>
                dispatch({
                    success: true,
                    type: getModalType(),
                })
            );
        }
    );
};

export const ruleConfigTradeOnboarding = {
    name: 'tradeOnboarding',
    priority: 450,
    rule: tradeOnboardingRule,
    action: tradeOnboardingShow,
};



// WEBPACK FOOTER //
// ./src/notificationQueue/globalNotifications/tradeOnboarding.js